
import { defineComponent } from 'vue';
import Feature from './Feature.vue';

export default defineComponent({
  components: {
    Feature,
  },
});
